import script from "./ResetPassword.vue?vue&type=script&lang=ts&setup=true"
export * from "./ResetPassword.vue?vue&type=script&lang=ts&setup=true"

import "./ResetPassword.vue?vue&type=style&index=0&id=0995ba14&lang=scss"

const __exports__ = script;

export default __exports__